import { ConfiguratorStatus } from '../enums'

/** Statuses that hide the whole configurator surface from the customer. */
const CUSTOMER_HIDDEN: ConfiguratorStatus[] = [ConfiguratorStatus.INTERNAL]

/**
 * Whether the configurator exists for this reader at all.
 *
 * An advisor sees it in every status, INTERNAL included — that is what the
 * shadow view is for. For the customer, INTERNAL answers the way a missing
 * project does, and the screen must offer no way in.
 *
 * Shared because both sides decide it: the server refuses the read, and the
 * customer's project page decides whether to show the link. Said twice, a
 * status added here shows a link the server then refuses.
 */
export const mayReadConfigurator = (
  project: { configuratorStatus: ConfiguratorStatus },
  { seesInternal }: { seesInternal: boolean },
): boolean =>
  seesInternal || !CUSTOMER_HIDDEN.includes(project.configuratorStatus)
